// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__DERg5","overlay":"Modal_overlay__TbN9v"};